import { createWorkspaceServiceClient } from '@nimbus/workspace-service';
import { generalEnv } from '@nx-frontend/shared/env';

export const getWorkspaceRoles = async (userId: number, workspaceId?: string): Promise<Record<string, string>> => {
  const workspaceServiceClient = createWorkspaceServiceClient({
    basePath: generalEnv.workspaceServiceUrl + '/v1',
    secret: generalEnv.secret,
    superSecret: generalEnv.superSecret,
  });

  const result = await workspaceServiceClient.AccessApi.apiGetRoles({ workspaceId }, { userId });
  return result.data;
};
